import 'consumerweb-shim';
import 'core-js/stable'; // If imports from pp-react are required, please test this component on IE
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import IntialData from '../../utility/getTemplateData';
import Illustration from '../../components/illustrations/Illustration';
import Footer from '../../components/footer/footer';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import { hideSpinnerOverlay } from '../../utility/helper';
import _get from 'lodash/get';
import * as FPT from '../../utility/fpt';
import { isMobileOrInContext } from '../../utility/inContextDonation';

import '../../../css/ppvx-app.less';
import '../../../css/ppvx.less';

const messages = localsMessages('errors/500') || {};
const webscrMessages = localsMessages('errors/webscr') || {};
let webscrData = templateData.webscrData || {};

class WebscrError extends React.Component {
  state = {};

  componentDidMount() {
    const webscrErrorCode = IntialData.webscrErrorCode;
    hideSpinnerOverlay();
    FPT.trackPage(
      'main:donate:wps::error',
      'main:donate:wps::error:web::',
      'ERROR_CODE',
      webscrErrorCode
    );
  }

  formatContent(content, data) {
    if (data && data.currency_code) {
      content = content.replace('{currency_code}', data.currency_code);
    }

    return content;
  }

  render() {
    const webscrErrorCode = IntialData.webscrErrorCode;
    let webscrErrorMessage = _get(
      webscrMessages,
      `webscr.error.${webscrErrorCode}`
    );
    if (!webscrErrorMessage) {
      webscrErrorMessage = _get(webscrMessages, `webscr.error.GENERIC_ERROR`);
    }
    webscrErrorMessage = this.formatContent(
      webscrErrorMessage,
      _get(webscrData, 'jsonParams', {})
    );

    return (
      <>
        <div
          className={`donate_wrapper ${
            isMobileOrInContext() ? 'mobile_view' : ''
          }`}
        >
          <div className="ppvx_row confirmation_sign_up_success">
            <div className="ppvx_col-sm-12 text-center">
              <div className="error_page_landing">
                <Illustration size="large" type="warning" />
                <p className="error_message">{webscrErrorMessage}</p>
                {/*<p className="error_message">{webscrErrorCode}</p>*/}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

ReactDOM.render(<WebscrError />, document.getElementById('donateWrapper'));
